import { render, staticRenderFns } from "./VeJwJingsaiGroupinfoModal.vue?vue&type=template&id=703bd875"
import script from "./VeJwJingsaiGroupinfoModal.vue?vue&type=script&lang=js"
export * from "./VeJwJingsaiGroupinfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports